<template>
     <div v-if="!hide" class="form-network form-network-instagram" >
        <details open>
            <summary>Visibilité <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch">
                    Partager automatiquement le post en story après sa publication
                    <ComponentSwitch :value="formData.formDataNetwork.instagram.shareInStory" :onChange="handlerSharePostInStory" :id="'switch-settings-advanced-instagram-1'"></ComponentSwitch>
                </div>
                <div class="list-simple-btn">
                    <div class="type-btn-simple" @click="addMode('addIdentifierMode')">
                        <i class="fa-regular fa-circle-user"></i>
                        <p>Personne Identifié <span class="pink">({{ formData.formDataNetwork && formData.formDataNetwork.instagram.personsIdentified ? formData.formDataNetwork.instagram.personsIdentified.length : '0' }})</span></p>
                        <!-- ou retirer une personne
                        <i class="fa-solid fa-plus"></i> -->
                    </div>
                    <div class="type-btn-simple" @click="addMode('addCollaboratorMode')">
                        <i class="fa-regular fa-circle-user"></i>
                        <p>Collaborateur <span class="pink">({{ formData.formDataNetwork && formData.formDataNetwork.instagram.personsIdentified ? formData.formDataNetwork.instagram.collaborators.length : '0' }})</span></p>
                        
                    </div>
                    <div class="type-btn-simple" @click="addMode('addPlaceMode')">
                        <i class="fa-solid fa-map-pin"></i>
                        <p>Lieu <span class="pink">({{ formData.formDataNetwork.instagram.place ? '1' : '0' }})</span></p>
                
                    </div>
                    <div class="type-btn-simple" @click="addMode('addMusicMode')">
                        <i class="fa-solid fa-music"></i>
                        <p>Musique <span class="pink">({{ formData.formDataNetwork.instagram.music ? '1' : '0' }})</span></p>
                    
                    </div>
                </div> 
              
            </div>      
        </details>
        <details open>
            <summary>Format <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="list-radio-btn" :class="{disable: ratioIsDisable}">
                    <div class="type-btn-simple" @click="changeRatio('1:1')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : ratioIsDisable || !formDataInstagram.ratio || formDataInstagram.ratio =='1:1'}"></i>
                        <p>Ratio 1:1</p>
                    </div>

                    <div class="type-btn-simple" @click="changeRatio('16:9')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !ratioIsDisable && formDataInstagram.ratio && formDataInstagram.ratio =='16:9'}"></i>
                        <p>Ratio 16:9</p>
                    </div>
                 
                    <div class="type-btn-simple" @click="changeRatio('4:5')">
                        <i class="fa-regular fa-circle" :class="{'fa-solid fa-circle-dot' : !ratioIsDisable && formDataInstagram.ratio && formDataInstagram.ratio =='4:5'}"></i>
                        <p>Ratio 4:5</p>
                    </div>
                   
                </div>  
            </div>      
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from './../../../../store/index.js';
    import ComponentSwitch from '../../utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '../../../mixins/Bots.vue'
    import minxinPost from '../../../mixins/Posts.vue'
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },
        },

        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                    urlImageSnippet: "",
                    titleSnippet: "",
                    descriptionSnippet: "",
                },

                formDataInstagram : {
                    personsIdentified : [],
                    collaborators : [],
                    place : undefined,
                    music : undefined,
                    ratio : undefined
                },

                lastModeSelected : undefined
            }
        },

        
        mounted() {
            EventBus.$on('eventSearchFromSelectPerson', this.searchPerson);
            EventBus.$on('eventClickSelectPerson', this.addPerson);
            EventBus.$on('eventRemoveSelectPerson', this.removePerson);

            EventBus.$on('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$on('eventClickSelectPlace', this.addPlace);
            EventBus.$on('eventRemoveSelectPlace', this.removePlace);

            EventBus.$on('eventSearchFromSelectMusic', this.searchMusic);
            EventBus.$on('eventClickSelectMusic', this.addMusic);
            EventBus.$on('eventRemoveSelectMusic', this.removeMusic);

            if (this.formData.formDataNetwork.instagram) this.formDataInstagram = this.formData.formDataNetwork.instagram

        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },
            async searchPerson(value,idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.getMentionsByApi(page.id, value, false)).body.mentions
                }
                EventBus.$emit("resultSearchFromSelectPerson", result,idEvent)
            },
            addPerson(person) {
                console.log("addPerson")
                switch (this.lastModeSelected) {
                    case 'addIdentifierMode':
                        this.formDataInstagram.personsIdentified = [...this.formDataInstagram.personsIdentified.filter(p => p.id !== person.id),person]
                        break;
                    case 'addCollaboratorMode':
                        this.formDataInstagram.collaborators = [...this.formDataInstagram.collaborators.filter(p => p.id !== person.id),person]
                        break;
                }
           
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            removePerson(idPerson) {


                switch (this.lastModeSelected) {
                    case 'addIdentifierMode':
                        this.formDataInstagram.personsIdentified = this.formDataInstagram.personsIdentified.filter(p => p.id !== idPerson)
                        break;
                    case 'addCollaboratorMode':
                        this.formDataInstagram.collaborators = this.formDataInstagram.collaborators.filter(p => p.id !== idPerson)
                        break;
                }
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },

            async searchPlace(network, value,idEvent) {
                if (network !== 'instagram') return
                let page = this.pagesSelected.find(p => p.story_config && p.story_config.created)
                
                let result = []
                if (page) {
                    result = (await this.getLocation(page.id, value)).body.locations
                }
                EventBus.$emit("resultSearchFromSelectPlace", result, idEvent)
            },
            addPlace(network, place) {
                if (network !== 'instagram') return
                this.formDataInstagram.place = place
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            removePlace(network) {
                if (network !== 'instagram') return
                this.formDataInstagram.place = undefined
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },

            async searchMusic(value,idEvent) {
                let page = this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                let result = []
                if (page) {
                    result = (await this.getMusicInstagram(page.id, value)).body.musics
                }
                EventBus.$emit("resultSearchFromSelectMusic", result, idEvent)
            },
            addMusic(music) {
                this.formDataInstagram.music = music
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            removeMusic() {
                this.formDataInstagram.music = undefined
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },

            changeRatio(ratio) {
                console.log("changeRatio",ratio)
                this.formDataInstagram.ratio = ratio
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            },
            handlerSharePostInStory(state) {
                this.formDataInstagram.shareInStory = state
                this.$emit('setFormDataNetwork', 'instagram', this.formDataInstagram)
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
            ratioIsDisable() {
                const files = this.formData.files.filter(file => ['video', 'image'].includes(file.type2))
                return files.length > 1 || (files.length == 1 && files[0].type2 == 'video')
            }
        },

        watch: {
            ['formData.formDataNetwork.instagram']() {
                if (this.formData.formDataNetwork.instagram) this.formDataInstagram = this.formData.formDataNetwork.instagram
            }
        },

        beforeDestroy () {
            EventBus.$off('eventSearchFromSelectPerson', this.searchPerson);
            EventBus.$off('eventClickSelectPerson', this.addPerson);
            EventBus.$off('eventRemoveSelectPerson', this.removePerson);

            EventBus.$off('eventSearchFromSelectPlace', this.searchPlace);
            EventBus.$off('eventClickSelectPlace', this.addPlace);
            EventBus.$off('eventRemoveSelectPlace', this.removePlace);

            EventBus.$off('eventSearchFromSelectMusic', this.searchMusic);
            EventBus.$off('eventClickSelectMusic', this.addMusic);
            EventBus.$off('eventRemoveSelectMusic', this.removeMusic);
        }
        
    }
</script>